/** Identifies this browser tab on every request, so only the tab that made an edit skips its echo. */
export const TAB_ID = crypto.randomUUID()
